module.exports = __webpack_public_path__ + "assets/img/17_995.07c87aaf.jpg";